// import createUseExtensionStorageCollection from "./createUseExtensionStorageCollection";
// import useExtensionStorage from './useEkey: string, INITIAL_IGNORED_PHRASE_RULES: unknown, p0: (pr1: any, pr2: any) => boolean, initialValue: TES: unknown, p0: (pr1: any, pr2: any) => boolean, initialValue: TES: unknown, p0: (pr1: any, pr2: any) => boolean, initialValue: Tge from "./useLocalStorage";

import useLocalStorage from "./useLocalStorage";

export type UseStateReturn<T> = [T | undefined, (value: T) => void];

// export const DEV_MODE_KEY = "devMode";
// export function useDeveloperMode(): UseStateReturn<boolean> {
//   return useExtensionStorage<boolean>(DEV_MODE_KEY);
// }

// export const DEV_SHOW_OVERLAYS = "devShowOverlays";
// export function useShowOverlays(): UseStateReturn<boolean> {
//   return useExtensionStorage<boolean>(DEV_SHOW_OVERLAYS);
// }

// export const DEV_SHOW_DOT_OVERLAYS = "devShowDotOverlays";
// export function useShowDotOverlays(): UseStateReturn<boolean> {
//   return useExtensionStorage<boolean>(DEV_SHOW_DOT_OVERLAYS);
// }

// export const DEV_SHOW_MIRRORS = "devShowMirrors";
// export function useShowMirrors(): UseStateReturn<boolean> {
//   return useExtensionStorage<boolean>(DEV_SHOW_MIRRORS);
// }

// export const DEV_TOOLS_SIZE = "devToolsNumber";
// export function useDevToolsSize(): UseStateReturn<number> {
//   return useExtensionStorage<number>(DEV_TOOLS_SIZE);
// }

// export const DEV_TOOLS_IS_OPEN = "devToolsIsOpen";
// export function useDevToolsIsOpen(): UseStateReturn<boolean> {
//   return useLocalStorage<boolean>(DEV_TOOLS_IS_OPEN, false);
// }

// export const BLOCKED_ORIGINS = "blockedOrigins";
// const INITIAL_BLOCKED_ORIGINS: string[] = [];

// export const useBlockedOrigins = createUseExtensionStorageCollection<string>(
//   BLOCKED_ORIGINS,
//   INITIAL_BLOCKED_ORIGINS
// );

// export const FEEDBACK_LANGUAGE = 'feedbackLanguage';
// export function useFeedbackLanguage(): UseStateReturn<AdviceLanguage> {
//     return useExtensionStorage<AdviceLanguage>(
//         FEEDBACK_LANGUAGE,
//         GrammarClient.DEFAULT_ADVICE_LANGUAGE,
//     );
// }

export type PhraseRule = {
  phrase: string;
  rule: number;
};

export const IGNORED_PHRASE_RULES = "ignoredPhraseRules";
const INITIAL_IGNORED_PHRASE_RULES: [] = [];

export const useIgnoredPhraseRules =
  createUseExtensionStorageCollection<PhraseRule>(
    IGNORED_PHRASE_RULES,
    INITIAL_IGNORED_PHRASE_RULES,
    (pr1, pr2) => {
      return pr1.phrase === pr2.phrase;
    }
  );

export type ExtensionStorage<T> = {
  values: T[] | undefined;
  has: (t: T) => boolean;
  toggle: (t: T) => void;
};

export default function createUseExtensionStorageCollection<T>(
  key: string,
  initialValues: T[],
  eq: (t1: T, t2: T) => boolean = Object.is
) {
  return (): ExtensionStorage<T> => {
    const [values, setValues] = useLocalStorage<T[]>(key, initialValues);
    const has = (value: T) => values?.find((v) => eq(v, value)) !== undefined;

    const toggle = (value: T) => {
      if (value !== undefined && values !== undefined) {
        if (has(value)) {
          // remove from the list
          setValues(values.filter((v) => v !== value));
        } else {
          // add to the list
          setValues([...values, value]);
        }
      }
    };

    return {
      values,
      has,
      toggle,
    };
  };
}
